import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useState, useEffect } from "react";

// Public pages
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import Security from "@/pages/Security";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Login from "@/pages/Login";

// Protected app pages
import Messages from "@/pages/app/Messages";
import MessageDetail from "@/pages/app/MessageDetail";
import Settings from "@/pages/app/Settings";
import Profile from "@/pages/app/Profile";
import VoiceConfig from "@/pages/app/VoiceConfig";
import AdminNumbers from "@/pages/app/AdminNumbers";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('fruitycall_auth') === 'true';
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/comment-ca-marche" element={<HowItWorks />} />
          <Route path="/security" element={<Security />} />
          <Route path="/securite" element={<Security />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/mentions-legales" element={<Legal />} />
          <Route path="/login" element={<Login />} />
          <Route path="/connexion" element={<Login />} />
          
          {/* Protected app routes */}
          <Route
            path="/app/messages"
            element={
              <ProtectedRoute>
                <Messages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/messages/:id"
            element={
              <ProtectedRoute>
                <MessageDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/voice-config"
            element={
              <ProtectedRoute>
                <VoiceConfig />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/admin/numbers"
            element={
              <ProtectedRoute>
                <AdminNumbers />
              </ProtectedRoute>
            }
          />
          
          {/* Redirect /app to /app/messages */}
          <Route path="/app" element={<Navigate to="/app/messages" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;